//Componente Front-end
/**
 * @file Controla a execução em jogo, por exemplo acerto de palavras, principalmente, administrar os
 * vetores de controle das posições e <i>status</i> das palavras.
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */
import {Alert} from 'rsuite';
/**
 * A module that shouts hello!
 * @module ControlGame
 */

/** Controla a execução em jogo, por exemplo acerto de palavras, principalmente, administrar os
 * vetores de controle das posições e <i>status</i> das palavras.*/
export default class ControlGame {
    /**
     * @constructs ControlGame
     * @description Acessa as pré-configurações geradas pela classe [Controle do nível]{@link module:ControlLevel}
     * @property {Number} largura - Quantidade de colunas.
     * @property {Number} altura - Qunatidade de linhas.
     * @property {Number} base_pontos - Constant - base de pontos para acerto.
     * @property {Number} pontos - Armazena os pontos correntes do jogador.
     * @property {Array} palavras - Lista de palavras e referências.
     * @property {Array} teste - Matriz de referência de todas as letras do tabuleiro.
     * @property {boolean} fim - Gatilho para finalizar o jogo.
     * @property {Number} palavrasCertas - Lista de rotulo das palavras certas para controle das dicas e acertos.
     * @property {Number} refPalavrasCertas - Lista da referência das palavras certas para marcações das células corretas no tabuleiro.
     * @param {Number} largura - Quantidade de colunas.
     * @param {Number} altura - Qunatidade de linhas.
     * @param {Array} palavras - Lista de palavras e referências.
     * @returns Indiretamente as referências geradas seram utilizadas pelo [Controle do Board]{@link module:Board}
     */
    
    constructor(palavras, largura, altura) {
        this.largura = largura;
        this.altura = altura;
        this.base_pontos = 500;
        this.pontos = 0;
        this.palavras = palavras;
        this.teste = Array(largura * altura).fill(0);
        this.fim = false;
        this.palavrasCertas = Array(palavras.palavras.length).fill();
        this.refPalavrasCertas = Array(largura * altura).fill(false);
    }

    /**
      * @description Incrementa pontuação
      * @param {Number} c Pontuação a ser descontada do placar
      */
    setAjuda(c){
        this.pontos -= c;
    }

    /**
      * @description Certifica se a letra esta selecionada ou não
      * @param {Number} c Referência da letra no tabuleiro.
      */
    checkLetra(c) {
        this.teste[c] = this.teste[c] === 0 ? 1 : 0;
        this.palavraLetra(c);

    }

    /**
      * @description Certifica se a letra esta selecionada ou não
      * @param {Number} c Referência da letra no tabuleiro.
      */
    palavraLetra(c) {
        for (let index = 0; index < this.palavras.posicoes.length; index++) {
            if (this.palavras.posicoes[index].includes(c)) this.acertoPalavra(index);
        }
    }

    /**
      * @description Certifica se a letra esta selecionada ou não
      * 
      * @param {String} palavra Palavra envolvida na seleção do usuário para verificar acerto.
      */
    acertoPalavra(palavra) {
        let palavraTest = this.palavras.posicoes[palavra];
        let acerto = true;
        for (let index = 0; index < palavraTest.length; index++) {
            if (this.teste[palavraTest[index]] === 0) acerto = false;
        }

        if (acerto === true) this.acerto(palavra);

    }

    /**
      * @description Gerência as respostas visuais das palavras certas
      * @param {Array} index Refência das posições da palavra acertada pelo usuário. 
      */
    acerto(index) {
        Alert.success('Você encontrou '+this.palavras.palavras[index]+', parabéns!');
        this.pontos += this.base_pontos;
        for (let ind = 0; ind < this.palavras.posicoes[index].length; ind++) {
            this.refPalavrasCertas[this.palavras.posicoes[index][ind]]=  true;            
        }
        this.palavrasCertas[this.palavras.ref[index]] = true;     
        this.palavras.posicoes  = this.arrayRemove(this.palavras.posicoes, this.palavras.posicoes[index]);       
        this.palavras.palavras  = this.arrayRemove(this.palavras.palavras, this.palavras.palavras[index]);
        this.palavras.ref  = this.arrayRemove(this.palavras.ref, this.palavras.ref[index]);   
        this.vitoria();
    }

    vitoria() {
        if (this.palavras.posicoes.length === 0)
            this.fim = true;
    }

    getRefPalavrasCertas(){
        return this.refPalavrasCertas;
    }

    getPalavrasCertas(){
        return this.palavrasCertas;
    }

    getVitoria(){
        return this.fim;
    }

    getPontos() {
        return this.pontos;
    }

    getAcertos() {
        return this.pontos / this.base_pontos;
    }

    getPalavras(){
        return this.palavras;
    }

    arrayRemove(lista, value) {

        return lista.filter(function (ele) {
            return ele !== value;
        });

    }


}
